
export const Community_Physician_ID = "117"

export const PEDIATRIC_ASSOCIATES_ID = "462";

export const SOUTHSIDE_MEDICAL_CENTER_ID = "165";

export const FOUR_CORNERS_PRIMARY_CARE_CENTERS_ID = "387";

export const OPTIMAL_CARE_ID = "1245";

export const D_G_Medical_Associates_ID = "450";

export const EVERGREEN_PEDIATRICS_PLLC_ID = "233";

export const ETHIZO_ID = "111";

export const Juniper_Healthcare  = '1236';

export const BEHAVIORAL_CARE_SOLUTIONS_ID = "1104";

export const IMPACT_HEALTH_PC = "1218";

export const IMPACT_ID = "1218";

export const SUMMIT_MEDICAL_CONSULTANTS_ID = "204";

export const MID_ATLANTIC="1232"

export const ABODE_CARE_PARTNERS = "1237"

export const GREAT_CARE_AND_WELLNESS = "4131"

// CC-76180: Journey Medical Care Group — skip sign note + eSuperbill confirmation
export const JOURNEY_MEDICAL_CARE_GROUP_ID = "4001";

export const HDC_PRACTICE_ID = "1190"

export const CARE_MED_PRACTICE_ID = "3003"

export const MERIDIAN_HEALTH_PARTNERS_PRACTICE_ID = "1262"

export const TRUMEN_PRACTICE_ID = "1036"

export const MEDCAP_PRACTICE_ID = "1247"

export const REHABILITATION_ASSOCIATES_ID = "1240"

export const FutureCare_Rehabiliation_ID = "3005"

export const IsIncidentToBillingPractice = practiceId => {
    return practiceId == ETHIZO_ID ||
        practiceId == Juniper_Healthcare ||
        practiceId == REHABILITATION_ASSOCIATES_ID ||
        practiceId == OPTIMAL_CARE_ID ||
        practiceId == D_G_Medical_Associates_ID;
}

export const IsDngPractice = practiceId => {
    return practiceId == "450" || practiceId == "459";
}

export const VALLEY_MEDICAL_PRACTICE_ID = "1230";

export const CENTRIC_PHYSICIANS_GROUP_ID="1191"

export const APPELO_PRACTICE_ID = "2093"

export const DESTINY_INTERNAL_MEDICAL_PRACTICE_ID = "1242"

export const isAzrielBellyPractice = practiceId => {
    return practiceId == "2102";
}

export const isBridgeHealthcarePractice = practiceId => {
    return practiceId == "2122";
}

export const isTHREEOAKSPractice = practiceId => {
    return practiceId == "2108" || practiceId == "2121";
}